/**
 * Warning icon with a caret popover explaining that a customer-part line's delivery date is TBD
 * until the sales rep confirms it. Every caller passes its own content's
 * `customerPartDeliveryDateMessage`.
 *
 * Rendered by the delivery-date and TBD-icon cells of the cart, checkout, order confirmation,
 * quote details and Easy Quote tables (for example
 * `ShoppingCart/ShoppingCartTable/ShoppingCartTableTBDIconCell.tsx`). The `mixed-plant-tbd-warning`
 * test id is asserted by `unit-tests/checkout/HoldToShip/checkoutDeliveryTBDIconCell.spec.tsx`
 * and `checkoutDeliveryDateCell.spec.tsx`.
 */
import React from "react";
import { Flex, FlexItem } from "@ryerson/frontend.layout";
import { Popover } from "@ryerson/frontend.modal";
import { Icon } from "@ryerson/frontend.assets";
import { Typography } from "@ryerson/frontend.typography";
import { useTheme } from "@ryerson/frontend.theme";

interface CustomerPartTBDWarningPopoverProps {
	/** Opens on tap when true; on hover otherwise. */
	isMobile: boolean;
	message: string;
}

/** TBD warning icon and popover; see the file header. */
export const CustomerPartTBDWarningPopover: React.FC<CustomerPartTBDWarningPopoverProps> = ({
	isMobile,
	message,
}) => {
	const { theme } = useTheme();
	const { gray, white } = theme.colors.primary;

	return (
		<FlexItem css={{ width: "fit-content" }}>
			<Popover
				alignment={"bottom"}
				className="popover-menu"
				caretColor={gray}
				popoverType="caret"
				hover={!isMobile ? true : false}
				offset={[0, 12]}
				trigger={<Icon icon={"warning"} size="sm" />}
			>
				<Flex
					direction="column"
					alignItems="center"
					justifyContent="center"
					css={{
						backgroundColor: gray,
						padding: 10,
						width: "300px",
					}}
				>
					<Typography
						css={{
							color: white,
						}}
						dataTestId="mixed-plant-tbd-warning"
					>
						{message}
					</Typography>
				</Flex>
			</Popover>
		</FlexItem>
	);
};
